const useAddressService = () => {
    const addressByCep = async (cep) => {
        try {
            const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
            const data = await response.json();
            if (data.erro) {
                return { success: false, offline: false, data: null };
            }
            return { success: true, offline: false, data: data };
        } catch (error) {
            return { success: false, offline: true, data: null };
        }
    };

    return { addressByCep };
};

export default useAddressService;
